import React from 'react';
import useStyles from './Styles';
import {Tools} from './Tools';

interface Props {
    owner_id: number,
    img_id: number,
    name?: string,
    className?: "imgItemLarge" | "imgItemPhoto" | "imgSortItem" | "imgList" | "imgProfile" | "imgProfileHeader" | "imgProfilePhoto",
}

const StoreImg:React.FC<Props> = (props)=> {
    const classes = useStyles();
    if(!props.img_id){
        return (null);
    }
    if( props.owner_id===0 || props.img_id===0 ){
        return (null);
    }

    const src = Tools.getStoreImg(props.owner_id,props.img_id);

    let name = "画像";
    if( props.name ){
        name = props.name;
    }

    let classname = "";
    if( props.className ){
        classname = classes[ props.className ];
    } else {
        classname = classes.img;
    }

	return (
        <img src={src} title={name} alt={name} className={classname}/>
    );
}

export default StoreImg;
